module.exports = __webpack_public_path__ + "img/HeaderIcon.afa449f0.svg";